import axios from "axios";
import useAuthStore from './stores/auth.store'


const axiosInstance = axios.create({
    baseURL: import.meta.env.VITE_BACKEND_URL,
});

// Refresca el access token si ya venció (y cierra sesión si venció el refresh token). Devuelve el token vigente.
// También lo usa "Ver logs (Hangfire)", que manda el token sin pasar por axios (DGL-355).
export async function ensureFreshAccessToken() {
    let store = localStorage.getItem("access_token") ? localStorage : sessionStorage;

    if (store.getItem("refresh_token_expiration") < new Date().getTime() && store.getItem("refresh_token") ) {
        console.log('Refresh token expirado')
        const auth = useAuthStore()
        await auth.logout()
    }

    if (store.getItem("access_token_expiration") < new Date().getTime() && store.getItem("refresh_token") ) {
        let new_access_token = await axios.post(`${import.meta.env.VITE_BACKEND_URL}api/login/refresh/`, {
            refreshToken: store.getItem("refresh_token")
        });
        
        const auth = useAuthStore()

        auth.refreshToken(new_access_token.data.token)
    }

    return store.getItem("access_token");
}

axiosInstance.interceptors.request.use(
    async config => {
        config.headers.Authorization = `Bearer ${await ensureFreshAccessToken()}`;
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);


export default axiosInstance;